import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  Badge,
} from '../ui'
import type { LatenessRecord } from '../../types/reports.types'

interface LatenessTableProps {
  records: LatenessRecord[]
}

export function LatenessTable({ records }: LatenessTableProps) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Сотрудник</TableHead>
          <TableHead>Организация</TableHead>
          <TableHead>Подразделение</TableHead>
          <TableHead>График</TableHead>
          <TableHead>Время входа по графику</TableHead>
          <TableHead>Время фактического входа</TableHead>
          <TableHead>Время опоздания</TableHead>
          <TableHead>Статус графика</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {records.map((record) => (
          <TableRow key={record.employee_id}>
            <TableCell>
              <div className="space-y-1">
                <p className="font-medium">{record.employee_name}</p>
                {record.employee_number && (
                  <p className="text-sm text-muted-foreground">
                    {record.employee_number}
                  </p>
                )}
              </div>
            </TableCell>
            <TableCell>
              {record.organization_name || (
                <span className="text-muted-foreground">-</span>
              )}
            </TableCell>
            <TableCell>
              {record.department_name || (
                <span className="text-muted-foreground">-</span>
              )}
            </TableCell>
            <TableCell>
              {record.schedule_name || (
                <span className="text-muted-foreground">-</span>
              )}
            </TableCell>
            <TableCell>
              {record.scheduled_start || (
                <span className="text-muted-foreground">-</span>
              )}
            </TableCell>
            <TableCell>
              {record.actual_arrival || (
                <span className="text-muted-foreground">-</span>
              )}
            </TableCell>
            <TableCell>
              {record.late_minutes > 0 ? (
                <span className="font-medium text-red-600">
                  {record.late_minutes} мин
                </span>
              ) : (
                <span className="text-muted-foreground">-</span>
              )}
            </TableCell>
            <TableCell>
              {record.is_off_schedule && (
                <Badge variant="secondary" className="bg-red-100 text-red-800">
                  Вне графика
                </Badge>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
